angular.module('common.template.additional-codes.popup',['common.filter.description']).controller('AdditionalCodesPopupController',
    function(CONSTANTS, $uibModalInstance, $uibModal, simulationDate, additionalCodes, commodityCode){
        var adcosPopupCtrl = this;
        adcosPopupCtrl.additionalCodes = additionalCodes;
        adcosPopupCtrl.simulationDate = simulationDate;
        adcosPopupCtrl.commodityCode = commodityCode;
        adcosPopupCtrl.dateFormat = CONSTANTS.dateFormat;
        adcosPopupCtrl.close = function (){
            $uibModalInstance.dismiss('Close');
        };
        
        adcosPopupCtrl.openFootnotePopup = function (size, footnoteId){
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/footnote/footnote-popup.tmpl.html',
                controller: 'FootnotePopupController as footnotePopupCtrl',
                size: size,
                resolve: {
                    footnote: function (FootnotePopupModel) {
                        return FootnotePopupModel.findFootnote(footnoteId, adcosPopupCtrl.simulationDate);
                    }
                }
            });
        };
    });


// WEBPACK FOOTER //
// ./app/common/popup/additional-codes/additional-codes-popup.js